import { toast } from "react-toastify"
import { Manual, ManualMeta } from "models/manual"

const API = process.env.REACT_APP_API_URL

// GET /manual — manuals the current user can see (filtered by their screens)
export const getManuals = async (): Promise<ManualMeta[] | null> => {
  try {
    const res = await fetch(`${API}/manual`, { method: "GET", credentials: "include" })
    const body = await res.json()
    if (!res.ok) throw new Error(body.message)
    return body.data
  } catch (err: any) {
    toast.error(err.message ?? "Error getting manuals")
    return null
  }
}

// GET /manual/view?slug=...
export const getManual = async (slug: string): Promise<Manual | null> => {
  try {
    const res = await fetch(`${API}/manual/view?slug=${encodeURIComponent(slug)}`, {
      method: "GET",
      credentials: "include",
    })
    const body = await res.json()
    if (!res.ok) throw new Error(body.message)
    return body.data
  } catch (err: any) {
    toast.error(err.message ?? "Error getting manual")
    return null
  }
}

// GET /manual/asset?path=... — returns an object URL for an <img>, or null
export const getManualAssetUrl = async (path: string): Promise<string | null> => {
  try {
    const res = await fetch(`${API}/manual/asset?path=${encodeURIComponent(path)}`, {
      method: "GET",
      credentials: "include",
    })
    if (!res.ok) return null
    return URL.createObjectURL(await res.blob())
  } catch {
    return null
  }
}
